<template>
  <div class="gyjy2">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="onClickLeft"
      class="topBar"
    />
    <div style="height: 45px"></div>
    <van-form @submit="onSubmit">
      
      <!-- <van-field
        v-model="jyjg.yhdd"
        name="维护区域"
        label="维护区域"
        placeholder="请输入维护区域"
        :rules="[{ required: true, message: '请输入维护区域' }]"
      /> -->
      <van-field
        readonly
        clickable
        name="维护区域"
        v-model="jyjg.yhdd"
        label="维护区域"
        placeholder="请选择维护区域"
        @click="lxPicker = true"
        :rules="[{ required: true, message: '请选择维护区域域' }]"
      />
      <van-popup v-model="lxPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="lxPicker = false"
          value-key="name"
        />
      </van-popup>


      <van-field
        v-model="jyjg.czwt"
        rows="2"
        autosize
        label="描述"
        type="textarea"
        maxlength="200"
        placeholder="请输入描述"
        show-word-limit
         :rules="[{ required: true, message: '请输入描述' }]"
      />
      
      <van-field
        v-model="jyjg.bz"
        name="备注"
        label="备注"
        placeholder="请输入备注"
      />
      <!--<van-field
        v-model="jyjg.pjr"
        name="陪检人"
        label="陪检人"
        placeholder="请输入陪检人"
      />
       <van-field
        v-model="jyjg.jcdw"
        name="维护单位"
        label="维护单位"
        placeholder="请输入维护单位"
        :rules="[{ required: true, message: '请输入维护单位' }]"
      />-->
       <van-field
        v-model="jyjg.jcry"
        name="维护人"
        label="维护人"
        placeholder="请输入维护人"
        :rules="[{ required: true, message: '请输入维护人' }]"
      />
       <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="jyjg.jcrq"
        label="维护时间"
        placeholder="点击选择时间"
        @click="timePicker = true"
      />
      <van-popup v-model="timePicker" position="bottom">
        <van-datetime-picker
          type="datetime"
          @confirm="onTimeConfirm"
          @cancel="timePicker = false"
          v-model="testtime2"
        /> 
        <!-- <van-datetime-picker
          type="datetime"
          @confirm="onTimeConfirm"
          @cancel="timePicker = false"
          v-model="testtime2"
          :min-date="minDate"
          :max-date="maxDate"
        /> -->
      </van-popup>
      <div class="fjsc" v-if="type=='add'">
        <p>维护图片</p>
        <van-uploader
          accept="image/*"
          result-type="file"
          v-model="fileList1"
          :after-read="afterRead1"
          :delete="del1"
        />
      </div>
      <div class="fjsc" v-if="type!='add'">
        <p>维护图片</p>
        <van-uploader
          accept="image/*"
          result-type="file"
          v-model="fileList1"
          :after-read="afterRead1"
          :delete="del1"
          class="yhsp"
        />
      </div>
      <div style="margin: 16px" v-if="type=='add'">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <div class="cover" id="cover"></div>
  </div>
</template>
<script>
let moment = require("moment");
import _URL from "../../lib/url";
import { Toast, Dialog, RadioGroup, Radio, PullRefresh } from "vant";
import { getAction, postAction, putAction, deleteAction } from "@/api/manage";
import { uniqueSort } from "jquery";
export default {
  name: "index",
  data: function () {
    return {
      minDate:'',
      maxDate:'',
      jyjg: {
          sblx:"",
          ssqy:"",
          ssbmname:"",
          ssbmid:"",
          ssbzname:"",
          ssbzid:"",
          yhlx:"",
          czwt:"",
          yhdj:"",
          isfk:"是",
          jcrq: "",
          bz: "",
          pjr:"",
          jcdw:"",
          jcry:"",
          name:"",
          userid:"",
          ssdwname:"",
          ssdwid:"",
          flag:'wh',
      },
      xf:{
				 yqzgr:'',//维护整改人
				 yqzgrid :'',//维护整改人id
				 zgyq :'',//整改要求
				 xzsj :'',//要求整改时间
      },
      zg:{
         id:this.$route.query.id, //维护ID
			   sjzgrq :'',
				 sjzgms :'',
				 userid :localStorage.getItem('uid'),
				 name:localStorage.getItem('realname'),
         yhnr:[]
      },
      yq:{
         id:this.$route.query.id, //维护ID
				 name:localStorage.getItem('realname'),//登录用户真实名称
				 userid:localStorage.getItem('uid'),//登录用户ID
         yqhzgr:localStorage.getItem('realname'),//登录用户真实名称
				 yqhzgrid:localStorage.getItem('uid'),//登录用户ID
				 yqhzgrq:'',//延期后整改日期
				 yqyy:''//延期原因
      },
      ys:{
         id:this.$route.query.id, //维护ID   验收通过  验收不通过
				 ysr:localStorage.getItem('realname'),//登录用户真实名称//验收人
				 ysrq:'',//验收日期
				 ysqk:'', //验收情况
				 ysjg:'验收通过' //验收结果   验收通过  验收不通过
      },
      title: this.$route.query.title,
      timePicker: false,
      timePicker2: false,
      timePicker3:false,
      timePicker4:false,
      lxPicker:false,
      qyPicker:false,
      zyPicker:false,
      bjcPicker:false,
      yhlxPicker:false,
      yhdjPicker:false,
      zgrPicker:false,
      testtime2: "",
      fileList1: [],
      fileList2: [],
      columns: [],
      columnsQy:[],
      columnsZy:[],
      columnsBjc:[],
      columnsYhlx:[],
      columnsZgr:[],
      columnsYhdj:['重大','一般A','一般B','一般C'],
      fkje:[
        {
          "fkr":"",
          "fkrje":""
        }
      ],
      type:'',
      showBtn:'',
      yqShow:false,
      peoKey:'',
    };
  },
  mounted: function () {
    let that = this;
    let user =  JSON.parse(localStorage.getItem('user'))
   // let nowDate = new Date().getTime()
    that.minDate = new Date(moment().subtract(2, "days").format("YYYY-MM-DD"))
    that.maxDate = new Date(moment().add(1, "days").format("YYYY-MM-DD"))
    that.jyjg.jcrq = moment().format("YYYY-MM-DD HH:mm:ss");
    that.jyjg.jcry =user.realName;
    that.jyjg.czwt='无';
    that.ys.ysrq = moment().format("YYYY-MM-DD HH:mm:ss");
    that.testtime2 = new Date();
    let type = that.$route.query.type;
    that.type = that.$route.query.type;
    that.showBtn = that.$route.query.showBtn;
    if (type != "add") {
      //获取基本信息
      that.getGydt(this.$route.query.id);
      //获取罚款人列表
      //that.getFkr(this.$route.query.id);
      //获取附件
      that.getfj(this.$route.query.id);
      //获取整改时上传的附件
      if(type>=3){
        that.getfjZg(this.$route.query.id);
      }
    }
    //获取各种选项
     that.getSblx()
    // that.getSsqy()
    // that.getZy()
    //获取项目部
    // that.getBjc(localStorage.getItem("ssbmid"))
    // that.getYhlx()
    // that.getZgr()
    //that.getliangjv()
  },
  methods: {
    //延期审核
    goSp(val){
        let that = this;
        let datas = {
           id:this.$route.query.id, //维护ID
           yqsp:'同意'
        }
        if(!val){
          datas.yqsp="不同意"
        }
        getAction(`${_URL.yhsbspSave}`,datas).then(
          (res) => {
          //  console.log(JSON.stringify(res));
            if (res.resultCode=="success") {
              Toast.success("提交成功");
              that.$router.go(-1);
            } else {
              Toast.fail("提交失败，请重试");
            }
          }
        );
    },
    //提交延期信息
    onYq(){
        let that = this;
        getAction(`${_URL.yhsbyqSave}`, that.yq).then(
          (res) => {
          //  console.log(JSON.stringify(res));
            if (res.resultCode=="success") {
              Toast.success("延期申请提交成功");
              that.$router.go(-1);
            } else {
              Toast.fail("提交失败，请重试");
            }
          }
        );
    },
    goYq(){
      let that = this
      let id = this.$route.query.id
      that.yqShow = true
      //alert(id);
      // that.$router.push({
      //   path:'things',
      //   query:{
      //     type:'2.5',
      //     showBtn:true,
      //     title:'申请延期',
      //     id:this.$route.query.id
      //   }
      // });
    },
    //获取整改人字典
    getZgr(){
      let that = this;
      let obj = {
          name:that.peoKey,
          ssbzid:that.jyjg.ssbzid
      };
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      getAction(`${_URL.userList}`, obj).then((res) => {
      //  console.log(JSON.stringify(res));
        Toast.clear();
        that.columnsZgr = res;
      });
    },
    getFkr(id){
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let obj = {
        id: id,
      };
      getAction(`${_URL.yhsbfkrjelist}`, obj).then((res) => {
        if (res.code=="200") {
          //  that.fkje = res.data
          let data = res.data
          for(var i=0;i<data.length;i++){
            data[i]['fkrje'] =  data[i]['fkrje'].replace('元','');
          }
          that.fkje = data
          Toast.clear();
        } else {
          Toast.fail("罚款人获取失败");
        }
      });
    },
    closeRy(val){
      this.fkje.splice(val,1);
    },
    addperson(){
      this.fkje.push({
        "fkr":"",
        "fkrje":""
      })
    },
    //获取维护类型字典
    getYhlx(){
      let that = this;
      let obj = {
        datatype:"YinHuanLeiXing",
        ssbmid:that.jyjg.ssbmid
      };
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      getAction(`${_URL.dictionarysj}`, obj).then((res) => {
        Toast.clear();
        that.columnsYhlx = res.resultData;
      });
    },
    //被维护单位字典
    getBjc(val){
      let that = this;
      let obj = {
        roleid:localStorage.getItem("roleid"),
        roletype:localStorage.getItem("roletype"),
        ssbzid:localStorage.getItem("ssbzid"),
        ssbzname:localStorage.getItem("ssbzname"),
        ssbmid:val,
      };
      // ssbmid:localStorage.getItem("ssbmid"),
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      getAction(`${_URL.bzlist}`, obj).then((res) => {
        Toast.clear();
        that.columnsBjc = res.resultData;
      });
    },
    //专业字典
    getZy(){
      let that = this;
      let obj = {
        roleid:localStorage.getItem("roleid"),
        roletype:localStorage.getItem("roletype"),
        ssbmid:localStorage.getItem("ssbmid"),
        ssbmname:localStorage.getItem("ssbmname"),
        ssdwid:localStorage.getItem("ssdwid")
      };
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      getAction(`${_URL.bmlist}`, obj).then((res) => {
        console.log(JSON.stringify(res));
        Toast.clear();
        let columnsZy = []
        for(var i=0;i<res.resultData.length;i++){
          if(res.resultData[i]['isvalid']==0){
            columnsZy.push(res.resultData[i])
          }
        }
        that.columnsZy = columnsZy
      });
    },
    //获取上报类型字典
    getSblx(){
      let that = this;
          let obj = {
            userid:localStorage.getItem('uid'),
            pageNum:1,
            pageSize:10000,
            pid:1
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(`${_URL.zzjgList}`, obj).then((res) => {
            Toast.clear();
            that.columns = res.data.rows;
          });
    },
    //获取所属区域字典
    getSsqy(){
      let that = this;
      let obj = {
        datatype:"QuYu"
      };
      Toast.loading({
        message: "数据加载中...",
        forbidClick: true,
        duration: 0,
      });
      getAction(`${_URL.dictionarysj}`, obj).then((res) => {
        Toast.clear();
        that.columnsQy = res.resultData;
      });
    },
    //选择了上报类型
    onConfirm(value) {
      this.jyjg.yhdd = value.name;
      this.lxPicker = false;
    },
    //选择了所属区域
    onConfirmQy(value) {
      this.jyjg.ssqy = value.name;
      this.qyPicker = false;
    },
    //选择了专业
    onConfirmZy(value) {
      this.jyjg.ssbmname = value.name;
      this.jyjg.ssbmid = value.id;
      this.zyPicker = false;
      //根据专业获取新的维护类型
      this.getYhlx();
      //根据专业获取被维护单位
      this.getBjc(value.id)
    },
    //选择了被维护区域
    onConfirmBjc(value){
      this.jyjg.ssbzname = value.name;
      this.jyjg.ssbzid = value.id;
      this.bjcPicker = false;
      this.getZgr();

    },
    //选择了维护类型
    onConfirmYhlx(value){
      this.jyjg.yhlx = value.name;
      this.yhlxPicker = false;
    },
    //选择了维护等级
    onConfirmYhdj(value){
      this.jyjg.yhdj = value;
      this.yhdjPicker = false;
    },
    //选择了整改人
    onConfirmZgr(value){
      this.xf.yqzgr = value.name;
      this.xf.yqzgrid = value.id;
      this.zgrPicker = false;
    },
    //获取附件
    getfj(id) {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      
      let obj = {
        pid: id,
        pageNum:1,
        pageSize:1000,
      };
      getAction(`${_URL.yhsbzblist}`, obj).then((res) => {
        if (res.flag==true) {
          for (var i = 0; i < res.data.length; i++) {
            //两类图片根据名称区分
              that.fileList1.push({
                url:`${_URL.fileUrl}`+ res.data[i].realname,
              });
          }
          Toast.clear();
        } else {
          Toast.fail("附件获取失败");
        }
      });
    },
    //获取整改附件
    getfjZg(id) {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let obj = {
        id: id,
      };
      getAction(`${_URL.yhsbzgfjlist}`, obj).then((res) => {
        console.log(JSON.stringify(res));
        if (res.flag==true) {
          for (var i = 0; i < res.data.length; i++) {
            //两类图片根据名称区分
              that.fileList2.push({
                url: `${_URL.fileUrl}` + res.data[i].realname,
              });
          }
          Toast.clear();
        } else {
          Toast.fail("附件获取失败");
        }
      });
    },
    afterRead1(file) {
      let that = this;
      var formData = new FormData();
      // HTML 文件类型input，由用户选择
      formData.append("file", file.file);
      file.status = "uploading";
      file.message = "上传中...";
      postAction(`${_URL.uploadify}`, formData).then((res) => {
        console.log(JSON.stringify(res));
        if (res) {
          file.status = "done";
          file.url = `${_URL.fileUrl}` + res.data;
        } else {
          file.status = "failed";
          file.message = "上传失败";
          let index = that.fileList1.indexOf(file);
          that.fileList1.splice(index, 1);
        }
      });
    },
    afterRead2(file) {
      let that = this;
      var formData = new FormData();
      // HTML 文件类型input，由用户选择
      formData.append("file", file.file);
      file.status = "uploading";
      file.message = "上传中...";
      postAction(`${_URL.uploadify}`, formData).then((res) => {
       // console.log(JSON.stringify(res));
        if (res) {
          file.status = "done";
          file.url = "http://82.156.70.102:8020/newbuilt/files/files/" + res[0].realname;
        } else {
          file.status = "failed";
          file.message = "上传失败";
          let index = that.fileList2.indexOf(file);
          that.fileList2.splice(index, 1);
        }
      });
    },
    del1(val) {
    //  console.log(JSON.stringify(val));
    },
    del2(val) {
     // console.log(JSON.stringify(val));
    },

    getGydt(id) {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let obj = {
        id: id,
      };
      //根据维护单id获取维护单内容
      getAction(`${_URL.yhsbDetail}`, obj).then((res) => {
        if (res.flag==true) {
          console.log('dddd'+JSON.stringify(res));
          that.jyjg = res.data;
          that.testtime2 = new Date(res.data.jcrq);
          //回显下发字段
          that.xf.yqzgr= that.jyjg.yqzgr;
          that.xf.xzsj= that.jyjg.xzsj;
          //回显整改字段
          that.zg.sjzgrq= that.jyjg.sjzgrq;
          that.zg.sjzgms= that.jyjg.sjzgms;
          that.zg.yhnr= that.jyjg.yhnr;
          //回显延期字段
          that.yq.yqhzgrq= that.jyjg.yqhzgrq;
          that.yq.yqyy= that.jyjg.yqyy;   
          //回显验收字段
          that.ys.ysqk =  that.jyjg.ysqk;   
          that.ys.ysjg =  that.jyjg.ysjg;   
          //
          var files=JSON.parse(res.data.filename);
          for (var i = 0; i < files.length; i++) {
            //两类图片根据名称区分
            that.fileList1.push({
                url:`${_URL.fileUrl}`+ files[i].realname,
              });
          }
          Toast.clear();
        } else {
          Toast.fail("详情获取失败");
        }
      });
    },
    onClickLeft: function () {
      this.$router.go(-1);
    },
    onSubmit() {
      Toast.loading({
        message: "正在保存...",
        forbidClick: true,
        duration: 0,
      });
      //保存维护结果
      let that = this;
      let type = that.$route.query.type;
      if (type == "add") {
        let imgs = that.fileList1;
        let imgObj= []
        for (var i = 0; i < imgs.length; i++) {
            imgObj.push({
             "realname": imgs[i].url.replace(`${_URL.fileUrl}`,''),
            })
        }
        var data = that.jyjg;
        data.fknr = JSON.stringify(that.fkje);
        //data.filename = JSON.stringify(imgObj);
        data.filename = JSON.stringify(imgObj);
        data.yqzgr = that.xf.yqzgr;
        data.yqzgrid = that.xf.yqzgrid;
        data.zgyq = that.xf.zgyq;
        data.xzsj = that.xf.xzsj;
        console.log(JSON.stringify(data));
        postAction(`${_URL.zdxcSave}`, data).then(
          (res) => {
         //console.log(JSON.stringify(res));
            if (res.flag==true) {
              Toast.success("保存成功");
               that.$router.go(-1);
            } else {
              Toast.fail("保存失败，请重试");
            }
          }
        );
      }
      if (type == "1") {
          getAction(`${_URL.yhsbxfSave}`, that.xf).then(
            (res) => {
             //   console.log(JSON.stringify(res));
              if (res.resultCode=="success") {
              Toast.success("下发成功");
                that.$router.go(-1);
              } else {
                Toast.fail("保存失败，请重试");
              }
            }
          );
      }
      if (type == "3") {
         let imgs = that.fileList2;
          let imgObj= []
          for (var i = 0; i < imgs.length; i++) {
              imgObj.push({
              "realname": imgs[i].url.replace('http://82.156.70.102:8020/newbuilt/files/files/',''),
              })
          }
        that.zg.yhnr = JSON.stringify(imgObj);
          getAction(`${_URL.yhsbzgSave}`, that.zg).then(
            (res) => {
            //    console.log(JSON.stringify(res));
              if (res.resultCode=="success") {
              Toast.success("整改情况提交成功");
                that.$router.go(-1);
              } else {
                Toast.fail("保存失败，请重试");
              }
            }
          );
      }
      if (type == "4") {
          getAction(`${_URL.yhsbysSave}`, that.ys).then(
            (res) => {
              if (res.resultCode=="success") {
                Toast.success("验收情况提交成功");
                that.$router.go(-1);
              } else {
                Toast.fail("保存失败，请重试");
              }
            }
          );
      }
      
    },
    onTimeConfirm(time) {
      this.jyjg.jcrq = moment(time).format("YYYY-MM-DD HH:mm:ss");
      this.timePicker = false;
    },
    onTimeConfirm2(time) {
      this.xf.xzsj = moment(time).format("YYYY-MM-DD HH:mm:ss");
      this.timePicker2 = false;
    },
    onTimeConfirm3(time) {
      this.zg.sjzgrq = moment(time).format("YYYY-MM-DD HH:mm:ss");
      this.timePicker3 = false;
    },
    onTimeConfirm4(time) {
      this.yq.yqhzgrq = moment(time).format("YYYY-MM-DD HH:mm:ss");
      this.timePicker4 = false;
    },
  },
};
</script>
<style lang="less">
.gyjy2 {
  .cover{
    position: absolute;
    z-index: 8888;
    top:0;
    left:0;
    width:100%;
    height: 0px;
    background: rgba(0,0,0,0.5);
  }
  .yhsp{
    .van-uploader__upload{
        display: none !important;
    }
    .van-uploader__preview-delete{
        display: none;
    }
  }
    
  .searched {
    z-index: 9999;
    width:100%;
  }
  .van-sidebar-item__text {
    font-size: 15px !important;
  }
  .topBar::after {
    border-bottom-width: 0;
  }
  min-height: 100vh;
  background: #f9f9f9;
  .reposition {
    position: relative;
    top: -9px;
  }
  .rpb {
  }
  .banners {
    width: 100%;
  }
  .van-grid-item__content--center {
    color: #3780f1;
  }
  .more {
    float: right;
    color: rgb(100, 100, 100);
  }
  .arrow {
    position: relative;
    top: 2px;
  }
  .gdTitles {
    line-height: 40px;
    margin-top: 10px;
    background: white;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 15px;
    color: #1760cc;
    position: relative;
    z-index: 2000;
  }
  .potos {
    font-size: 22px;
    position: relative;
    top: 5px;
  }
  .fkrs{
    border:blue 1px dashed;
    width:90%;
    margin-left:5%;
    margin-top:10px;
    margin-bottom: 10px;
    font-size:14px;
    background: white;
  }
  .initit{
    width: 98px;
    line-height: 40px;
    margin-left: 10px;
    color: #646566;
  }
  .ri{
    height: 40px;
    background: white;
  }
  .ritem{
    border-bottom: dashed 1px rgb(230,230,230);
    background: white;
  }
  .ri1{
    position: relative;
    top:5px;
  }
  .ri2{
    position: relative;
    bottom:5px;
  }
  .inp::-webkit-input-placeholder{
    color:#c8c9cc;
  }
  .delIcon{
    font-size: 25px;
    margin-top:25px;
    margin-right:10px;
    color: #3780f1;
  }
  .addperson{
    color: #3780f1;
    line-height: 40px;
  }
}
</style>